import React from 'react';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import Button from 'material-ui/Button';
import {FormControlLabel} from 'material-ui/Form';

import tsl from '../tsl';

class Login extends React.Component {

    state = {
        'email': '',
        'password': ''
    };

    onChange = (e) => {
        let newState = this.state;
        newState[e.target.name] = e.target.value;
        
        this.setState(newState);
    };

    submit = (e) => {
        e.preventDefault();

        this.props.onLogin(this.state.email, this.state.password);
    };

    onForgotPassword = () => {
        this.props.history.push('/app/password-reset');
    };

    render() {
        return (
            <div
                className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
                <div className="login-content">
                    <div className="login-header mb-4">
                        <a className="app-logo" href="#/" title="Jambo">
                            <img src="./assets/images/logo-white-red.png" alt="jambo" title="jambo"/>
                        </a>
                    </div>

                    <div className="login-form">
                        <form method="post" action="/" onSubmit={this.submit}>
                            <fieldset>
                                <TextField
                                    name="email"
                                    value={this.state.email}
                                    onChange={this.onChange}
                                    label={tsl("login.email")}
                                    fullWidth
                                    margin="normal"
                                    className="mt-1"
                                />
                                <TextField
                                    type="password"
                                    name="password"
                                    value={this.state.password}
                                    onChange={this.onChange}
                                    label={tsl("login.password")}
                                    fullWidth
                                    margin="normal"
                                    className="mt-1"
                                />
                                
                                <br /><br />

                                <Button type="submit" raised color="primary"
                                    className="jr-btn text-white btn-primary"
                                >
                                    {tsl("login.signin.btn")}
                                </Button>

                                <Button onClick={this.onForgotPassword}>
                                    {tsl("login.forgotpass.btn")}
                                </Button>

                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
};

export default Login;



// WEBPACK FOOTER //
// ./app/used/Login.js